/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import showObject from '../../../../utils/showObject';

const TitleLineH2 = ({
  activeLanguage, handlerSetComponents, components, languages, id, reusableComponent, reusableComponentSlugname, slider,
}) => {
  const initialState = {
    type: 'TitleLineH2',
    text: {
      en: '',
    },
    color: slider ? 'white' : 'black',
    isHeadTitle: false,
    bgColor: false,
    textAlign: false,
  };
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isColorWhite, setColorWhite] = useState(false);
  const [showOptions, setShowOptions] = useState(false);

  const [text, setText] = useState({ 'en': '' });
  const [bgColor, setBgColor] = useState('#000000');
  const [color, setColor] = useState('#FFFFFF');

  const [isHeadTitle, setIsHeadTitle] = useState(false);
  const [textAlign, setTextAlign] = useState(false);

  useEffect(() => {
    if (slider) {
      setColorWhite(true);
      const comp = {
        ...state,
        color: 'white',
      };
      setState(comp);
    } else {
      setColorWhite(false);
      const comp = {
        ...state,
        color: 'black',
      };
      setState(comp);
    }
  }, []);

  const inputHandler = (e) => {
    const { value, name, lang } = e.target;

    const { component } = components[index];

    const comp = {
      ...component,
      [name]: {
        ...component[name],
        [lang.toLowerCase()]: value,
      },
    };

    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };

    handlerSetComponents(componentObj, index);
  };

  const setChangeColor = () => {
    setColorWhite(!isColorWhite);

    if (index >= 0 && components.length) {
      const { component } = components[index];
      const borderColor = !isColorWhite ? 'white' : 'black';

      const comp = {
        ...component,
        color: borderColor,
      };
      setState(comp);

      const componentObj = {
        id,
        component: comp,
      };

      handlerSetComponents(componentObj, index);
    }
  };

  // useEffect(() => {
  //   if (index >= 0 && components.length) {
  //     const { component } = components[index];
  //     const borderColor = isColorWhite ? 'white' : 'black';

  //     const comp = {
  //       ...component,
  //       color: borderColor,
  //     };
  //     setState(comp);

  //     const componentObj = {
  //       id,
  //       component: comp,
  //     };

  //     handlerSetComponents(componentObj, index);
  //   }
  // }, [isColorWhite]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {

        const {
          text,
          color: currentColor,
          bgColor: currentBgColor,
          isHeadTitle: currentIsHeadTitle,
          textAlign: currentTextAlign,
        } = component;

        setState(component);
        setText(text);
        setColor(currentColor);
        setBgColor(currentBgColor);
        setIsHeadTitle(currentIsHeadTitle);
        setTextAlign(currentTextAlign);

      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const construction = {
      type: state.type,
      compId: state.compId || '',
      text: { ...text },
      color,
      bgColor,
      isHeadTitle,
      textAlign,
    }
    handlerSetComponents({ component: construction }, componentIndex);
  }, [
    text,
    color,
    bgColor,
    isHeadTitle,
    textAlign,
  ]);

  const titleChange = (e) => {
    text[activeLanguage] = e.target.value
    setText({ ...text });
  }

  return (
    <div className="flex justify-start flex-col text-black">
      {/* Single Form */}
      <div className="flex items-end py-4">
        <div className="w-full md:w-full md:mb-0">
          <label
            className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            htmlFor="grid-first-name">
            Title
              </label>
          <input
            className="appearance-none block
            bg-gray-200 text-gray-700 border border-red-500
            rounded py-3 px-4 w-full leading-tight focus:outline-none
            focus:bg-white"
            id="grid-first-name"
            type="text"
            onChange={titleChange}
            value={text[activeLanguage]}
          />
        </div>
        <div
          className={`bg-blue-light border-blue-darker ml-4 cursor-pointer flex items-center justify-center py-6 rounded text-center text-white w-10`}
          onClick={() => setShowOptions(!showOptions)}
        >
          <svg
            className={`fill-current h-4 w-4 ${showOptions ? 'rotate-180' : ''}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
            /></svg>
        </div>
      </div>
      {/* End */}
      {/* BLOCK OPTIONS */}
      {/* <div className="border rounded w-full"> */}
      {/* <div
          className={`bg-blue-darker border-blue-darker h-5 ${showOptions ? 'rounded-t mb-4' : 'rounded'} text-center text-white cursor-pointer`}
          onClick={() => setShowOptions(!showOptions)}
        >
          <svg
            className={`fill-current h-4 w-4 ${showOptions ? 'rotate-180' : ''}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
            /></svg>
        </div> */}
      { showOptions && (
        <div className="flex justify-between sm:flex-wrap w-full xs:flex-wrap">
          {/* Double Color Form */}
          <div className="md:mr-4 xl:mr-4 lg:mr-4 xl:w-1/4 lg:w-1/4 w-full">
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="grid-first-name">
              Text Color
                </label>
            <div className="relative">
              <input
                className="appearance-none uppercase block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                id="grid-first-name"
                type="text"
                onChange={e => setColor(e.target.value)}
                value={color}
              />
              <input
                className="absolute bg-transparent flex h-full items-center p-1 right-0 text-gray-700 top-0"
                name="color"
                type="color"
                onChange={e => setColor(e.target.value)}
                value={color}
              />
            </div>
          </div>
          <div className="md:mr-4 xl:mr-4 lg:mr-4 xl:w-1/4 lg:w-1/4 w-full">
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="grid-last-name">
              Background Color
                </label>
            <div className="relative">
              <input
                className="appearance-none uppercase block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                id="grid-last-name"
                type="text"
                onChange={e => setBgColor(e.target.value)}
                value={bgColor}
              />
              <input
                className="absolute bg-transparent flex h-full items-center p-1 right-0 text-gray-700 top-0"
                name="color"
                type="color"
                onChange={e => setBgColor(e.target.value)}
                value={bgColor}
              />
            </div>
          </div>
          {/* End */}
          <div className="md:mr-4 xl:mr-4 lg:mr-4 xl:w-1/4 lg:w-1/4 w-full">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
              Head Title
                  </label>
            <div className="relative">
              <select
                className="block appearance-none w-full
                bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8
                rounded leading-tight focus:outline-none focus:bg-white
                focus:border-gray-500"
                value={isHeadTitle ? "true" : "false"}
                onChange={e => setIsHeadTitle(e.target.value === "true" ? true : false)}
              >
                <option value={false}>Default</option>
                <option value={true}>Yes</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0
              flex items-center px-2 text-gray-700 h-12 top-0">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  /></svg>
              </div>
            </div>
          </div>
          <div className=" xl:mr-4 lg:w-1/4 xl:w-1/4 w-full">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
              Text Align
                  </label>
            <div className="relative">
              <select
                className="block appearance-none w-full
                bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8
                rounded leading-tight focus:outline-none focus:bg-white
                focus:border-gray-500"
                value={textAlign}
                onChange={e => setTextAlign(e.target.value === "false" ? false : e.target.value)}
              >
                <option value={false}>Default</option>
                <option value={'left'}>Left</option>
                <option value={'center'}>Center</option>
                <option value={'right'}>Right</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0
              flex items-center px-2 text-gray-700 h-12 top-0">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                  /></svg>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* </div> */}
      {/* BLOCK OPTIONS */}

      {/* <label className={`flex flex-col font-americaMonoRegular ${slider ? 'text-xxs' : 'text-xs w-1/12 justify-center'} uppercase text-black pt-0 items-center px-2`}>
        Text Color
        <div className={`pb-0 ${slider ? 'mt-2px mx-2' : 'mt-6px ml-1'}`}>
          <label className="switch mb-0 pb-0 h-6">
            <input className="switch" checked={!!isColorWhite} onChange={setChangeColor} type="checkbox" />
            <div className="switch-slider btn-bw switch-round" />
          </label>
        </div>
      </label> */}
    </div>
  );
};

TitleLineH2.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  reusableComponent: PropTypes.shape(),
  slider: PropTypes.bool,
};
TitleLineH2.defaultProps = {
  reusableComponent: null,
  slider: false,
};

export default TitleLineH2;
